import React, { useState, useEffect } from "react";
import "../SummaryUpdated/summaryUpdated.css";
import { SquarePlay, Video } from 'lucide-react';
import axios from "../../../axios";
import { Link, NavLink } from "react-router-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { Tooltip } from "@mui/material";
import UnAuthAssessmentPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/UnAuthAssessmentPopup";
import InstructionsPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/InstructionsPopup";
import AssessmentNotAllowedPopup from "../../../DcmDetails/Assesment/Pending/QuestionTypes/AssessmentNotAllowedPopup";
import AllQuestions from "../../../DcmDetails/Assesment/Completed/QuestionCompleted/AllQuestions";
import { Player } from "video-react";
import { IP } from "./../../../internalServer";
import { iconData } from "../../../iconData";
import PdfViewer from "../../../HwManagement/PdfViewer/PdfViewer";
import { shortenParagraph } from "../../../utils/Engagement";
import { Grid, Card, CardContent, Typography } from "@mui/material";
import { X } from "lucide-react";
import PublishedQListPreRead from "../../../HwManagement/PreRead/Pending/PublishedQListPreRead";
import PreReadSuccessFromTimeTable from "../PreReadSuccessFromTimeTable";

export default function SummaryUpdated({
  assessmentId,
  CloseSummaryShowToday,
  data,
  open,
  setCloseSummaryPopup,
}) {
  /**
   * sets how to display day based events on the sj schedule day view component
   * @param {*} param0
   * @returns
   */
  const { state } = useLocation();
  const navigate = useNavigate();
  let StudentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [showModal, setShowModal] = useState(false);
  const [boradCastLink, setBoradCastLink] = useState('');
  const [noOnlineSession, setNoOnlineSession] = useState('');
  const [showPreRead, setShowPreRead] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [submitPopup, setSubmitPopup] = useState(false);
  function formatDate(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    // Pad single digits with a leading zero if needed
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;
    return `${formattedDay}/${formattedMonth}/${year}`;
  }
  function formatTime(dateString) {
    if (!dateString) return null;
    const date = new Date(dateString);
    const formattedTime = date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    return formattedTime;
  }

  function format_time(time) {
    if (!time || typeof time !== "string" || time.length < 4) {
      return "00:00:00";
    }
    const [hours, minutes] = time.match(/.{1,2}/g) || ["00", "00"];
    return `${hours}:${minutes}:00`;
  }

  function formateDateStartTime(summary) {
    if (!summary?.lecture?.start_time) return null;
    let start_time1 = format_time(summary?.lecture?.start_time);
    const date1 = new Date(summary?.schedule_date);

    let formattedDate = date1.toDateString();
    formattedDate = formattedDate.concat(
      ` ${start_time1} GMT+0530 (India Standard Time)`
    );
    return formattedDate;
  }

  function formateDateEndTime(summary) {
    if (!summary?.lecture?.end_time) return null;
    let end_time1 = format_time(summary?.lecture?.end_time);
    const date1 = new Date(summary?.schedule_date);
    let formattedDate = date1.toDateString();
    formattedDate = formattedDate.concat(
      ` ${end_time1} GMT+0530 (India Standard Time)`
    );
    return formattedDate;
  }

  const [summary, setSummary] = useState({});
  const [errMsg, setErrMsg] = useState("Something went Wrong!");
  const [unAuthPopup, setUnAuthPopup] = useState(false);
  const [instructionsPopup, setInstructionsPopup] = useState(false);
  const [notAllowedPopup, setNotAllowedPopup] = useState(false);
  const [currentAssessmentId, setCurrentAssessmentId] = useState(null);
  const [completedAssQestion, setCompletedAssQestion] = useState(false);
  const [compAssId, setComAssId] = useState("");
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [pedingSubDetail, setPedingSubDetail] = useState({
    pdfView: false,
  });
  const [summaryData, setSummaryData] = useState([]);
  useEffect(() => {
    const summaryCard = async () => {
      try {
        const supplementId = data?.SupplementId || state?.SupplementId;
        if (supplementId) {
          let response = await axios.get(
            `/summary/get/${supplementId}?studentId=${StudentData.id}`
            //`/summary/get/63e0a7ae3373bc5d8c9d6a7c?studentId=638dee5fc4d6787791bfa3b2`
          );
          if (response.data.data === null) {
            // open();
          } else {
            if (response) {
              setSummary(response?.data);
              setSummaryData(response?.data?.data);
            }
          }
        } else {
          CloseSummaryShowToday();
          setCloseSummaryPopup(false);
          open();
        }
      } catch (error) {
        console.log(error);
      }
    };
    summaryCard();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isReadyToOpen = async (assessmentId) => {
    if (summary?.data?.assessment) {
      try {
        const reshw = await axios.get(
          `/assessment/studentStatus/assessmentId/${assessmentId}/studentId/${StudentData.id}`
        );
        // console.log("reshw", reshw)
        const status = reshw?.data?.data?.status;
        switch (status) {
          case "pending":
            try {
              let res = await axios.get(
                `/assessment/getForStudent/${assessmentId}`
              );
              let res2 = await axios.get(
                `/assessment/getStartedFlag/assessmentId/${assessmentId}/studentId/${StudentData.id}`
              );

              if (res && res2) {
                setCurrentAssessmentId(assessmentId);
                if (res2?.data?.data?.started_flag === false) {
                  setInstructionsPopup(true);
                } else {
                  setNotAllowedPopup(true);
                }
                // navigate(`/Assessment/pending/questions/${currentAssessmentId}`)
              }
              if (res) {
                return true;
              }
            } catch (error) {
              setErrMsg(error?.response?.data?.message);
              setUnAuthPopup(true);
              return false;
            }

            break;
          case "review":
            navigate("/Assessment/review/questions", {
              state: { assessmentId: summary?.data?.assessment?.id },
            });
            break;
          case "completed":
            setCompletedAssQestion(true);
            setComAssId(summary?.data?.assessment?.id);
            //   navigate("/completedHomework", { state: { homeworkId: summary?.data?.homework?.id } })
            break;
          default:
            navigate("/Summary");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  const homeworkHelperFunc = async (homeworkId) => {
    if (summary?.data?.homework) {
      try {
        const reshw = await axios.get(
          `/homework/studentStatus/homeworkId/${homeworkId}/studentId/${StudentData.id}`
        );
        const status = reshw?.data?.data?.status;
        switch (status) {
          case "pending":
            navigate("/publishedhomework", {
              state: { homeworkId: summary?.data?.homework?.id },
            });
            break;
          case "review":
            navigate("/reviewHomework", {
              state: { homeworkId: summary?.data?.homework?.id },
            });
            break;
          case "completed":
            navigate("/completedHomework", {
              state: { homeworkId: summary?.data?.homework?.id },
            });
            break;
          default:
            navigate("/Summary");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };
  const preReadHelperFunc = async (preReadId) => {
    if (summary?.data?.pre_read) {
      try {
        const reshw = await axios.get(
          `/preRead/studentStatus/preReadId/${preReadId}/studentId/${StudentData.id}`
        );
        const status = reshw?.data?.data?.status;
        switch (status) {
          case "pending":
            navigate("/preReads/published", {
              state: { preReadId: summary?.data?.pre_read?.id },
            });
            break;
          case "completed":
            navigate("/presRead/completed", {
              state: { preReadId: summary?.data?.pre_read?.id },
            });
            break;
          default:
            navigate("/Summary");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const acticityHelperFunc = async (activityId) => {
    if (summary?.data?.activity) {
      try {
        const reshw = await axios.get(
          `/activity/studentStatus/activityId/${activityId}/studentId/${StudentData.id}`
        );
        console.log("reshw", reshw);
        const status = reshw?.data?.data?.status;
        console.log("status", status);
        switch (status) {
          case "pending":
            navigate("/publishedActivity", {
              state: { activityId: summary?.data?.activity?.id },
            });
            break;
          case "review":
            navigate("/reviewActivity", {
              state: { activityId: summary?.data?.activity?.id },
            });
            break;
          case "completed":
            navigate("/completedActivity", {
              state: { activityId: summary?.data?.activity?.id },
            });
            break;
          default:
            navigate("/Summary");
        }
      } catch (error) {
        console.log("error", error);
      }
    }
  };

  const handleOnlineSession = async (bbbClass_id) => {
    if (!bbbClass_id) return;
    try {
      let response;
      if (StudentData.school.liveClassType === 'broadcast') {
        response = await axios.get(
          `/videoConference/classes/getRecording/${bbbClass_id}`
        );
      } else {
        response = await axios.get(
          `/videoConference/classes/getCloudRecordingUrls/${bbbClass_id}`
        );
      }

      if (response.data.data.length > 0) {
        setBoradCastLink(response.data.data)
      } else {
        setNoOnlineSession(response?.data?.message)
      }

    } catch (error) {
      console.log("error", error);
    }
  }

  const bbbId = summary?.data?.bbbClass_id;

  useEffect(() => {
    handleOnlineSession(bbbId)
  }, [bbbId])

  const handleRemovePdfVivwer = () => {
    setPedingSubDetail({
      ...pedingSubDetail,
      pdfView: false,
    });
  };
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };

  return (
    <div className="summary_container p-4">
      <div className="flex">
        <img
          onClick={() => {
            if (state?.from === "summary") {
              navigate("/Summary");
            } else {
              if (CloseSummaryShowToday !== undefined) {
                CloseSummaryShowToday();
              } else {
                setCloseSummaryPopup(false);
              }
            }
          }}
          className="backArrow_summary"
          src="/DCM-img/BackArrowSummary.svg"
          alt=""
        ></img>
        <div className="summary_heading_dcm ">Today Summary</div>
      </div>
      <div
        className="summarySubContainer  mt-4  orange-scrollBar"
        style={{ overflowY: "scroll" }}
      >
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-2">
            <div>
              <img src="/DCM-img/SubjectIconSci.png" alt=""></img>
            </div>
            <div>
              <div className="subheading_dcm">
                {" "}
                {data?.name || summaryData?.lecture?.name || ""}
              </div>
              <span className="sumarySubjectDate">
                {data !== undefined
                  ? formatDate(data.StartTime)
                  : summaryData && formateDateStartTime(summaryData)
                    ? formatDate(formateDateStartTime(summaryData))
                    : null}
              </span>
              <span className="sumary_time">
                {" "}
                {data?.StartTime !== undefined
                  ? formatTime(data?.StartTime)
                  : formatTime(formateDateStartTime(summaryData))}{" "}
                -{" "}
                {data?.EndTime !== undefined
                  ? formatTime(data?.EndTime)
                  : formatTime(formateDateEndTime(summaryData))}
              </span>
            </div>
          </div>

          <div>
            <div>
              <span className="sumarySubjectDate">Subject :</span>&nbsp;
              <span className="subejctDetail">
                {data?.Subject || summaryData?.lecture?.subject?.name || ""}
              </span>
            </div>
            <div>
              <span className="sumarySubjectDate">Teacher :</span>&nbsp;
              <span className="subejctDetail">
                {data?.Teacher?.name ||
                  summaryData?.lecture?.teacher?.name ||
                  ""}
              </span>
            </div>
          </div>
        </div>

        <div className="col-12 row p-0 ">
          <div className="subContainer1 col-md-7 col-12 mt-2">
            <div className="Lesson_Description">Lecture Instruction</div>
            {summaryData?.lecInstruction ? (
              <div className="Default_text paragraphLengthIns">
                {summaryData?.lecInstruction}
              </div>
            ) : (
              <>
                <p className="Default_text">
                  {`---`}
                </p>
              </>
            )}
            <div className="Lesson_Description">Lecture Summary</div>
            {summaryData?.description ? (
              <div className="Default_text paragraphLengthDesc">
                {" "}
                {summaryData?.description}
              </div>
            ) : (
              <>
                <p className="Default_text">{`---`}</p>
              </>
            )}

            <div className="main_attach_box">
              <div className="">
                <div className="sharedText">
                  Shared Files
                </div>
                {/*  */}
                <div className="orange-scrollBar" style={{ display: "flex", gap: "10px", padding: "12px 10px", overflowY: "scroll" }}>
                  {summaryData?.attachments?.length > 0 ? (
                    summaryData?.attachments?.map(
                      (attachment, index) => (
                        <div key={index} className="cardBox">
                          {attachment.split(".").pop() !== "mp4" ? (
                            <>
                              {attachment.split(".").pop() === "jpg" ||
                                attachment.split(".").pop() === "jpeg" ||
                                attachment.split(".").pop() === "JPEG" ||
                                attachment.split(".").pop() === "JPG" ||
                                attachment.split(".").pop() === "PNG" ||
                                attachment.split(".").pop() === "png" ? (
                                <img
                                  style={{
                                    width: 180,
                                    height: 180,
                                    flex: "0 0 auto", // ✅ prevent shrinking, align in row
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                  src={IP + attachment?.replace(/^\./, "")}
                                  alt="Attachment"
                                  onClick={() => {
                                    if (!isError) {
                                      handleClick(attachment);
                                    }
                                  }}
                                />
                              ) : attachment.split(".").pop() === "pdf" ? (
                                <div
                                  key={index}
                                  onClick={(e) => {
                                    setPedingSubDetail({
                                      ...pedingSubDetail,
                                      pdfView: true,
                                      attachment: attachment,
                                    });
                                  }}
                                  style={{
                                    width: 180,
                                    height: 180,
                                    flex: "0 0 auto", // ✅ prevent shrinking, align in row
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="m-auto">
                                    <div className="ml-[40px] mb-2">
                                      <img
                                        style={{ width: 60, height: 60 }}
                                        src={`${iconData?.find(
                                          (i) =>
                                            i.extension ===
                                            attachment?.match(/\.([^.]+)$/)[1]
                                        )?.icon
                                          }`}
                                        alt=""
                                      />
                                    </div>
                                    <div className="w-100">
                                      <div className="text-sm font-weight-medium text-center">
                                        {attachment?.replace(/^[^_]*_/, "")}
                                      </div>
                                      <div className="pdfFileSize text-center">12 KB</div>
                                    </div>
                                  </div>
                                </div>
                              ) : attachment.startsWith("https://") && (<div onClick={() => window.open(attachment, "_blank", "noopener,noreferrer")} className="m-auto">
                                <div className="ml-[30px] mb-2">
                                  <img
                                    src="/images/link-icon.png"
                                    alt=""
                                    className="w-10"
                                    style={{ width: 60, height: 60 }}
                                  />
                                </div>
                                <div className="text-sm font-weight-medium text-center">
                                  <div >
                                    {(() => {
                                      const today = new Date();
                                      const day = String(today.getDate()).padStart(2, "0");
                                      const month = String(today.getMonth() + 1).padStart(2, "0");
                                      const year = today.getFullYear();
                                      return `link_${day}-${month}-${year}`;
                                    })()}
                                  </div>
                                </div>
                              </div>)}
                            </>
                          ) : (
                            <div className="vidio_player mt-3" onClick={() => {
                              handleClick(attachment);
                            }}>
                              <div className="m-auto">
                                <div className="ml-[50px] mb-2">
                                  <img
                                    style={{ width: 60, height: 60 }}
                                    src={`${iconData?.find(
                                      (i) =>
                                        i.extension ===
                                        attachment?.match(/\.([^.]+)$/)[1]
                                    )?.icon
                                      }`}
                                    alt=""
                                  />
                                </div>
                                <div className="w-100">
                                  <div className="text-sm font-weight-medium text-center">
                                    {attachment?.replace(/^[^_]*_/, "")}
                                  </div>
                                  <div className="pdfFileSize text-center">12 KB</div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )
                    )
                  ) : (
                    <Card
                      sx={{
                        width: "100%",
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <Typography variant="body1" color="text.secondary">
                        📂 Shared files not available
                      </Typography>

                    </Card>

                  )

                  }
                </div>

              </div>
              <div className="preread_attachPdf">
                {/* {attach &&
              attach.map((obj, index) => (
                <AttachmentLM
                  attach={obj}
                  id={index}
                  fileSize={attachmentSize[index]}
                />
              ))} */}
              </div>
            </div>

          </div>
          <div className="col-md-1"></div>

          <div className="col-md-4 col-12 space-y-4">

            {/* ----------- Homework Card ----------- */}
            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-2">Homework</h2>

              {summary?.data?.homework ? (
                <div
                  className="cursor-pointer p-3 rounded-2xl shadow-md hover:shadow-lg transition-all bg-white"
                  onClick={() => homeworkHelperFunc(summary?.data?.homework?.id)}
                >
                  <div className="flex items-center gap-2 ">
                    <img src="/DCM-img/homework.svg" alt="" className="w-4" />
                    <h6 className="text-base font-medium mt-1">{summary?.data?.homework?.name}</h6>
                  </div>

                  <p className="text-sm text-gray-600 leading-relaxed">
                    <Tooltip
                      title={summary?.data?.homework?.description}
                      arrow
                      placement="bottom"
                    >
                      <span>
                        {shortenParagraph(summary?.data?.homework?.description, 100)}
                      </span>
                    </Tooltip>
                  </p>
                </div>
              ) : (
                <>
                  <div className="flex items-center gap-2 ">
                    <h6 className="text-base  font-medium mt-1 text-gray-400">None assigned at this time</h6>
                  </div>
                </>
              )}
            </div>

            {/* ----------- Pre-read Card ----------- */}
            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-2">Pre-read</h2>

              {summary?.data?.pre_read ? (
                <div
                  className="cursor-pointer p-3 rounded-2xl shadow-md hover:shadow-lg transition-all bg-white"
                  onClick={() => {
                    setSelectedId(summary?.data?.pre_read?.id);
                    setShowPreRead(true);
                  }
                  }
                >
                  <div className="flex items-center gap-2 mb-2">
                    <img src="/DCM-img/preread.svg" alt="icon" className="w-4" />
                    <h6 className="text-base font-medium mt-1">{summary?.data?.pre_read?.name}</h6>
                  </div>

                  <p className="text-sm text-gray-600 mb-3 leading-relaxed">
                    <Tooltip title={summary?.data?.pre_read?.description} arrow placement="bottom">
                      <span>
                        {shortenParagraph(summary?.data?.pre_read?.description, 250)}
                      </span>
                    </Tooltip>
                  </p>
                </div>
              ) : (
                <>
                  <div className="flex items-center gap-2">
                    <h6 className="text-base font-medium mt-1 text-gray-400">No pre-reading required for the next lesson</h6>
                  </div>
                </>
              )}
            </div>

            {/* ----------- Activity Card ----------- */}
            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-2">Activity</h2>

              {summary?.data?.activity ? (
                <div
                  className="cursor-pointer p-3 rounded-2xl shadow-md hover:shadow-lg transition-all bg-white"
                  onClick={() => acticityHelperFunc(summary?.data?.activity?.id)}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <img src="/DCM-img/activity.svg" alt="icon" className="w-4" />
                    <h6 className="text-base font-medium mt-1">{summary?.data?.activity?.name}</h6>
                  </div>

                  <p className="text-sm text-gray-600 mb-3 leading-relaxed">
                    <Tooltip title={summary?.data?.activity?.description} arrow placement="bottom">
                      <span>
                        {shortenParagraph(summary?.data?.activity?.description, 250)}
                      </span>
                    </Tooltip>
                  </p>
                </div>
              ) : (
                <>
                  <div className="flex items-center gap-2">
                    <h6 className="text-base font-medium mt-1 text-gray-400">No recent assignment activity!</h6>
                  </div>
                </>
              )}
            </div>

            {/* ----------- Assessment Card ----------- */}
            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-2">Assessment</h2>

              {summary?.data?.assessment ? (
                <div
                  className="cursor-pointer p-3 rounded-2xl shadow-md hover:shadow-lg transition-all bg-white"
                  onClick={() => isReadyToOpen(summary?.data?.assessment?.id)}
                >
                  <div className="flex items-center gap-2 mb-2">
                    <img src="/DCM-img/assessment.svg" alt="icon" className="w-4" />
                    <h6 className="text-base font-medium mt-1">{summary?.data?.assessment?.name}</h6>
                  </div>

                  <p className="text-sm text-gray-600 mb-3 leading-relaxed">
                    <Tooltip title={summary?.data?.assessment?.description} arrow placement="bottom">
                      <span>
                        {shortenParagraph(summary?.data?.assessment?.description, 250)}
                      </span>
                    </Tooltip>
                  </p>
                </div>
              ) : (
                <>
                  <div className="flex items-center gap-2">
                    <h6 className="text-base font-medium mt-1 text-gray-400">No pending/planned assessment</h6>
                  </div>
                </>
              )}
            </div>

            {/* ----------- Lecture Video Card ----------- */}
            <div className="bg-white rounded-xl shadow-md p-3 border border-gray-100">
              <h2 className="text-lg font-semibold text-gray-800 mb-2 border-b pb-2">Online Session Recording</h2>
              {console.log("summary?.data", summary?.data)
              }
              {summary?.data?.bbb_lecture_summary?.playback_url?.length > 0 ? (
                <>
                  <div className="flex items-center gap-2 mb-2">
                    <SquarePlay size={18} />
                    <h6 className="text-base font-medium mt-1">Video recording available</h6>
                  </div>

                  {summary?.data?.bbb_lecture_summary?.playback_url?.map((url, i) => (
                    <div key={i} className="flex justify-between items-center bg-gray-50 p-2 rounded-lg mb-2">
                      <p className="text-sm truncate text-gray-700">{url}</p>
                      <a href={url} target="_blank" className="text-orange-600 underline text-sm font-semibold">
                        View
                      </a>
                    </div>
                  ))}
                </>
              ) : (
                <>
                  {summary?.data?.bbbClass_id
                    ? (
                      <div className="flex items-center gap-2" onClick={() => setShowModal(true)}>
                        {noOnlineSession !== '' ? (
                          <span>--</span>
                        ) : (
                          <>
                            <Video />
                            <span>View Recording</span>
                          </>
                        )}
                      </div>
                    ) : (
                      <div className="flex items-center gap-2">
                        <h6 className="text-base font-medium mt-1 text-gray-400">
                          Recording not available
                        </h6>
                      </div>
                    )}
                </>
              )}
            </div>

          </div>

        </div>
      </div>
      {
        unAuthPopup && (
          <UnAuthAssessmentPopup
            setUnAuthPopup={setUnAuthPopup}
            errMsg={errMsg}
            closingWindowFlag={false}
          />
        )
      }
      {
        instructionsPopup && (
          <InstructionsPopup
            setInstructionsPopup={setInstructionsPopup}
            currentAssessmentId={currentAssessmentId}
          />
        )
      }
      {
        notAllowedPopup && (
          <AssessmentNotAllowedPopup
            setNotAllowedPopup={setNotAllowedPopup}
            currentAssessmentId={currentAssessmentId}
          />
        )
      }
      {
        completedAssQestion && (
          <AllQuestions
            assessmentId={compAssId}
            FromSummaryUpdate={"FromSummaryUpdate"}
          />
        )
      }
      {
        pedingSubDetail.pdfView && (
          <PdfViewer
            handleRemovePdfVivwer={handleRemovePdfVivwer}
            attachment={pedingSubDetail?.attachment}
          />
        )
      }
      {showPreRead && (
        <PublishedQListPreRead
          publishPre_id={selectedId}
          setShowPreRead={setShowPreRead}
          setSubmitPopup={setSubmitPopup}
        />
      )}
      {submitPopup && (
        <PreReadSuccessFromTimeTable
          setSubmitPopup={setSubmitPopup}
          setShowPreRead={setShowPreRead}
        />
      )}
      {
        isClicked &&
        (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              <video className="videoPlayer" controls>
                <source
                  src={IP + responseAttach.replace(/^\./, "")}
                  type="video/mp4"
                />
              </video>
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="fullSizeImg ">
            <div className="SubfullSizeImg">
              {!isError ? (
                <>
                  <img
                    className="imgMain"
                    src={IP + responseAttach?.replace(/^\./, "")}
                    alt="Full-size"
                    onError={(e) => {
                      setIsError(true);
                    }}
                  />
                  <div>
                    <img
                      className="crossIconImgQue"
                      onClick={handleClick}
                      src="/images/cross.png"
                      alt="Up Arrow"
                    />
                  </div>
                </>
              ) : (
                <div
                  className="fullSizeImg"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <img
                    onClick={() => {
                      setIsError(false);
                      handleClick();
                    }}
                    src="/images/cross.png"
                    alt="Up Arrow"
                    style={{ position: "absolute", top: "75px", right: "40%" }}
                  />
                  <img
                    src="/images/no-photo1.png"
                    alt="img"
                    style={{ width: "25%" }}
                  />
                  <p
                    style={{
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "500",
                      marginRight: "35px",
                    }}
                  >
                    Error!! failed to load the requested file!
                  </p>
                </div>
              )}
              {/* <img
                className="imgMain"
                src={IP + responseAttach?.replace(/^\./, "")}
                alt="Full-size"
              />
              <div>
                <img
                  className="crossIconImgQue"
                  onClick={handleClick}
                  src="/DCM-img/crossIcon.svg"
                  alt="Up Arrow"
                />
              </div> */}
            </div>
          </div>
        ))
      }
      {
        showModal && (
          <div className="ContainerSubmitedSucess2 ">
            <div className="SubContainerSubmitedSucessBoradcast">
              <div className="flex justify-between items-center">
                <h4 className="text-blue-950 font-semibold">Online Session</h4>
                <div className="mb-2 cursor-pointer"><X color="black" onClick={(e) => {
                  e.stopPropagation();
                  setShowModal(false)
                }} /></div>
              </div>
              <div>
                <iframe
                  src={boradCastLink}
                  width="900"
                  height="500"
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div >
        )
      }
    </div >
  );
}
